import { logoutUser } from '$services/session/logout/logout.service'
import { LifecyclePresenter } from '$views/components/utils/ConnectComponent'
import { View } from '$views/Logout/Logout.view'
import { routeProvider } from '../../utils/routeProvider'
import history from '$utils/history'

export class LogoutPresenter implements LifecyclePresenter<View> {
  // @ts-ignore
  private view!: View

  initialize(view) {
    this.view = view
  }

  onClick = async () => {
    try {
      await logoutUser()
      history.push(routeProvider.mainPage)
    } catch (error) {
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Logout/Logout.presenter.ts